import React from "react";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
/**
 * Nevyřízené požadavky page.
 */

class EmptyPage extends React.Component {
  render() {
    return (
      <CustomPageLayout title="Vstupní stránka" menu={<GroupMenu />}>
        <div>Vyberte položku v menu</div>
      </CustomPageLayout>
    );
  }
}

export default EmptyPage;
